module.exports = __webpack_public_path__ + "static/img/yunxilogo.1876597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/yunxilogo.png
// module id = sdiA
// module chunks = 44